<template>
  <div>

    <div>
      <b-button
        v-b-modal.modal-save-notification
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        type="submit"
        variant="success"
        class="mr-1"
      >
        Push Notification
      </b-button>
    </div>
    <br>

    <DataTable
      ref="notificationsTable"
      api="/admin/notifications"
      :on-row-selected-callback="onNotificationSelected"
    />

    <b-modal
      id="modal-save-notification"
      cancel-variant="outline-secondary"
      ok-title="Save"
      cancel-title="Close"
      centered
      size="lg"
      title="Push Notification"
      @ok="pushNotification"
    >
      <b-form>
        <b-form-group>
          <label>Title</label>
          <b-form-input
            id="title"
            v-model="notification.title"
            name="title"
            placeholder="Title"
          />
        </b-form-group>
        <b-form-group>
          <label>Body</label>
          <b-form-textarea
            id="body"
            v-model="notification.body"
            name="body"
            rows="3"
            placeholder="Body"
          />
        </b-form-group>
        <b-form-group>
          <label>Target Link</label>
          <b-form-input
            id="action"
            v-model="notification.action"
            name="action"
            placeholder="action"
          />
        </b-form-group>
<!--        <b-form-group>-->
<!--          <label>Click Action</label>-->
<!--          <b-form-select-->
<!--            id="click-action"-->
<!--            v-model="notification.clickAction"-->
<!--            :options="clickOptions"-->
<!--            name="click-action"-->
<!--            placeholder="Click Action"-->
<!--          />-->
<!--        </b-form-group>-->
        <b-form-group>
          <label>Type</label>
          <b-form-select
            id="type"
            v-model="notification.type"
            :options="typeOptions"
            name="type"
            placeholder="Type"
          />
        </b-form-group>
        <b-form-group>
          <label>Topic</label>
          <b-form-select
            id="type"
            v-model="notification.topic"
            :options="topicOptions"
            name="topic"
            placeholder="Topic"
          />
        </b-form-group>
        <b-form-group>
          <b-form-checkbox
            id="silent"
            v-model="notification.silent"
            name="approved"
          >
            Silent
          </b-form-checkbox>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import DataTable from '@core/components/data-table/DataTable.vue'
import firebase from 'firebase'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BFormGroup, BFormInput, BFormCheckbox, BForm, BFormTextarea, BFormSelect, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    DataTable,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BFormTextarea,
    BFormSelect,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      typeOptions: [
        { value: 'PROMOTIONAL', text: 'PROMOTIONAL' },
      ],
      topicOptions: [
        { value: '/topics/global-android-dev', text: 'ANDROID TESTING' },
        { value: '/topics/global-ios-dev', text: 'IOS TESTING' },
        { value: '/topics/global-android', text: 'ANDROID PRODUCTION' },
        { value: '/topics/global-ios', text: 'IOS PRODUCTION' },
      ],
      clickOptions: [
        { value: 'OPEN_ACTION_ACTIVITY', text: 'OPEN_ACTION_ACTIVITY' },
      ],
      notification: {
        title: '', body: '', action: '', type: 'PROMOTIONAL', clickAction: 'OPEN_ACTION_ACTIVITY', silent: false, id: undefined, topic: '/topics/global-android-dev',
      },
    }
  },
  methods: {
    onNotificationSelected(id) {
      if (id.length > 0) {
        this.$bvModal
          .msgBoxConfirm('Please confirm that you want to delete this notification.', {
            title: 'Please Confirm',
            size: 'sm',
            okVariant: 'danger',
            okTitle: 'Yes',
            cancelTitle: 'No',
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
          })
          .then(value => {
            if (value) {
              this.deleteNotification(id[0].id)
            }
          })
      }
    },
    deleteNotification(id) {
      const url = `${this.$readerURL}/admin/notifications/${id}`
      this.loader('block')
      const temp = this
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.delete(url,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          temp.$refs.notificationsTable.loadData()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    pushNotification() {
      const notification = {
        title: this.notification.title,
        body: this.notification.body,
        action: this.notification.action,
        clickAction: this.notification.clickAction,
        type: this.notification.type,
        topic: this.notification.topic,
        silent: this.notification.silent,
      }

      const url = `${this.$readerURL}/admin/notifications`
      this.loader('block')
      const temp = this
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.post(url, notification,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')

          temp.notification.title = ''
          temp.notification.body = ''
          temp.silent = true
          temp.action = ''
          temp.topic = '/topics/global-android-dev'
          temp.$refs.notificationsTable.loadData()
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Error ${error}`,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
  },
}
</script>
